/**
 * Command Bar Constants
 *
 * Centralized configuration for the command bar feature.
 * Extracted from CommandBar.tsx for maintainability and testability.
 */

// Layout constants
/** Maximum height of the results list, fits ~10 items without scroll */
export const COMMAND_BAR_MAX_HEIGHT = "480px";
/** Top margin positioning the bar in upper third of viewport */
export const COMMAND_BAR_TOP_MARGIN = "12vh";
/** Maximum width of the command bar */
export const COMMAND_BAR_MAX_WIDTH = "680px";

// Recent items constants
/** Maximum number of recent items to store in localStorage */
export const MAX_RECENT_ITEMS = 50;
/** Number of recent items to show in the command bar */
export const RECENT_ITEMS_DISPLAY_LIMIT = 5;

// Search constants
/** Debounce delay in ms for search queries - fast enough for responsive feel, slow enough to batch keystrokes */
export const SEARCH_DEBOUNCE_MS = 300;
/** Minimum query length before searching */
export const MIN_SEARCH_QUERY_LENGTH = 2;
/** Minimum query length before matching category keywords (e.g., "nav" for Navigation) */
export const MIN_CATEGORY_MATCH_LENGTH = 3;
